<a href="#main-content" class="go-to-top">
  <i class="fa fa-fw fa-chevron-up"></i>
  <span>
    Back
    <br />
    to Top
  </span>
</a>
